import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import zh_chs from "./zh_chs.json";
import tw from "./tw.json";
import tag from "./tag.json";
import vi from "./viet.json";
import { userLanguage } from "./detectLang";
import Cookies from "js-cookie";

const defaultLang = userLanguage();
i18n.use(initReactI18next).init({
  debug: false,
  lng:
    Cookies.get("language") !== undefined
      ? Cookies.get("language")
      : defaultLang === "en"
      ? "en"
      : defaultLang === "zh_chs"
      ? "zh_chs"
      : defaultLang === "tw"
      ? "tw"
      : defaultLang === "vi"
      ? "viet"
      : // : defaultLang === "PH"
        // ? "tag"
        "en",
  resources: {
    en: { translation: en },
    tw: { translation: tw },
    viet: { translation: vi },
    zh_chs: { translation: zh_chs },
    //tag: { translation: tag },
  },
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
